interface TrackEventProperties {
  [key: string]: any
}

export function trackClickEvent(eventName: string, properties: TrackEventProperties): void {
  try {
    window.pendo?.track(eventName, properties)
  } catch (error) {
    console.log(`Error tracking event: ${eventName}`, error)
  }
}
